import BallotIcon from "@mui/icons-material/Ballot";
import React, { memo } from "react";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#ef4444";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="Trocar Fluxo"
    accent={accent}
    icon={<BallotIcon sx={{ width: 15, height: 15, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={valuePill(accent)}>
      {data?.typebotIntegration?.message || data?.flow?.name || "Fluxo não selecionado"}
    </div>
  </NodeCard>
));
